<template>
  <div class="cvv-help" :class="{ left }">
    <div class="d-flex">
      <div>Visa, Master e outros: 3 dígitos no verso do cartão</div>
      <div>
        <svg
          width="54"
          height="40"
          viewBox="0 0 54 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_5003:119665)">
            <rect width="54" height="40" rx="8" fill="#D2D0D8" />
            <path
              d="M0 6.75C0 4.95979 0.711159 3.2429 1.97703 1.97703C3.2429 0.711158 4.95979 0 6.75 0H47.25C49.0402 0 50.7571 0.711158 52.023 1.97703C53.2888 3.2429 54 4.95979 54 6.75V10.125H0V6.75ZM0 16.875V33.75C0 35.5402 0.711159 37.2571 1.97703 38.523C3.2429 39.7888 4.95979 40.5 6.75 40.5H47.25C49.0402 40.5 50.7571 39.7888 52.023 38.523C53.2888 37.2571 54 35.5402 54 33.75V16.875H0ZM10.125 23.625H13.5C14.3951 23.625 15.2535 23.9806 15.8865 24.6135C16.5194 25.2465 16.875 26.1049 16.875 27V30.375C16.875 31.2701 16.5194 32.1285 15.8865 32.7615C15.2535 33.3944 14.3951 33.75 13.5 33.75H10.125C9.22989 33.75 8.37145 33.3944 7.73851 32.7615C7.10558 32.1285 6.75 31.2701 6.75 30.375V27C6.75 26.1049 7.10558 25.2465 7.73851 24.6135C8.37145 23.9806 9.22989 23.625 10.125 23.625Z"
              fill="#928F98"
            />
            <path
              d="M37.192 11.8V11.112H38.4773V15H37.7093V11.8H37.192ZM39.4496 14.1573C39.791 13.8729 40.063 13.6364 40.2656 13.448C40.4683 13.256 40.6372 13.0569 40.7723 12.8507C40.9074 12.6444 40.975 12.4418 40.975 12.2427C40.975 12.0613 40.9323 11.9191 40.847 11.816C40.7616 11.7129 40.6301 11.6613 40.4523 11.6613C40.2745 11.6613 40.1376 11.7218 40.0416 11.8427C39.9456 11.96 39.8958 12.1218 39.8923 12.328H39.167C39.1812 11.9013 39.3074 11.5778 39.5456 11.3573C39.7874 11.1369 40.0932 11.0267 40.463 11.0267C40.8683 11.0267 41.1794 11.1351 41.3963 11.352C41.6132 11.5653 41.7216 11.848 41.7216 12.2C41.7216 12.4773 41.647 12.7422 41.4976 12.9947C41.3483 13.2471 41.1776 13.4676 40.9856 13.656C40.7936 13.8409 40.543 14.0649 40.2336 14.328H41.807V14.9467H39.1723V14.392L39.4496 14.1573ZM42.2881 12.136C42.3059 11.7804 42.4303 11.5067 42.6615 11.3147C42.8961 11.1191 43.2037 11.0213 43.5841 11.0213C43.8437 11.0213 44.0659 11.0676 44.2508 11.16C44.4357 11.2489 44.5743 11.3716 44.6668 11.528C44.7628 11.6809 44.8108 11.8551 44.8108 12.0507C44.8108 12.2747 44.7521 12.4649 44.6348 12.6213C44.521 12.7742 44.3841 12.8773 44.2241 12.9307V12.952C44.4303 13.016 44.5903 13.1298 44.7041 13.2933C44.8215 13.4569 44.8801 13.6667 44.8801 13.9227C44.8801 14.136 44.8303 14.3262 44.7308 14.4933C44.6348 14.6604 44.4908 14.792 44.2988 14.888C44.1103 14.9804 43.8828 15.0267 43.6161 15.0267C43.2143 15.0267 42.8872 14.9253 42.6348 14.7227C42.3823 14.52 42.249 14.2213 42.2348 13.8267H42.9601C42.9672 14.0009 43.0259 14.1413 43.1361 14.248C43.2499 14.3511 43.4046 14.4027 43.6001 14.4027C43.7815 14.4027 43.9201 14.3529 44.0161 14.2533C44.1157 14.1502 44.1655 14.0187 44.1655 13.8587C44.1655 13.6453 44.0979 13.4924 43.9628 13.4C43.8277 13.3076 43.6179 13.2613 43.3335 13.2613H43.1788V12.648H43.3335C43.8383 12.648 44.0908 12.4791 44.0908 12.1413C44.0908 11.9884 44.0446 11.8693 43.9521 11.784C43.8632 11.6987 43.7335 11.656 43.5628 11.656C43.3957 11.656 43.2659 11.7022 43.1735 11.7947C43.0846 11.8836 43.033 11.9973 43.0188 12.136H42.2881Z"
              fill="#393444"
            />
            <circle
              cx="41"
              cy="13"
              r="5.75"
              stroke="#FF3F34"
              stroke-width="0.5"
            />
          </g>
          <defs>
            <clipPath id="clip0_5003:119665">
              <rect width="54" height="40" rx="8" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
    <hr />
    <div class="d-flex">
      <div>American Express: 4 dígitos na frente do cartão</div>
      <div>
        <svg
          width="54"
          height="40"
          viewBox="0 0 54 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_5003:119656)">
            <rect width="54" height="40" rx="8" fill="#D2D0D8" />
            <path
              d="M0 6.75C0 4.95979 0.711159 3.2429 1.97703 1.97703C3.2429 0.711158 4.95979 0 6.75 0H47.25C49.0402 0 50.7571 0.711158 52.023 1.97703C53.2888 3.2429 54 4.95979 54 6.75V23.625H0V6.75ZM38.8125 10.125C38.3649 10.125 37.9357 10.3028 37.6193 10.6193C37.3028 10.9357 37.125 11.3649 37.125 11.8125V15.1875C37.125 15.6351 37.3028 16.0643 37.6193 16.3807C37.9357 16.6972 38.3649 16.875 38.8125 16.875H45.5625C46.0101 16.875 46.4393 16.6972 46.7557 16.3807C47.0722 16.0643 47.25 15.6351 47.25 15.1875V11.8125C47.25 11.3649 47.0722 10.9357 46.7557 10.6193C46.4393 10.3028 46.0101 10.125 45.5625 10.125H38.8125ZM0 30.375V33.75C0 35.5402 0.711159 37.2571 1.97703 38.523C3.2429 39.7888 4.95979 40.5 6.75 40.5H47.25C49.0402 40.5 50.7571 39.7888 52.023 38.523C53.2888 37.2571 54 35.5402 54 33.75V30.375H0Z"
              fill="#928F98"
            />
            <path
              d="M35.168 26.2V25.598H36.2927V29H35.6207V26.2H35.168ZM37.1434 28.2627C37.4421 28.0138 37.6801 27.8069 37.8574 27.642C38.0348 27.474 38.1825 27.2998 38.3008 27.1193C38.419 26.9389 38.4781 26.7616 38.4781 26.5873C38.4781 26.4287 38.4408 26.3042 38.3661 26.214C38.2914 26.1238 38.1763 26.0787 38.0208 26.0787C37.8652 26.0787 37.7454 26.1316 37.6614 26.2373C37.5774 26.34 37.5339 26.4816 37.5308 26.662H36.8961C36.9085 26.2887 37.019 26.0056 37.2274 25.8127C37.439 25.6198 37.7065 25.5233 38.0301 25.5233C38.3848 25.5233 38.657 25.6182 38.8468 25.808C39.0365 25.9947 39.1314 26.242 39.1314 26.55C39.1314 26.7927 39.0661 27.0244 38.9354 27.2453C38.8048 27.4662 38.6554 27.6591 38.4874 27.824C38.3194 27.9858 38.1001 28.1818 37.8294 28.412H39.2061V28.9533H36.9008V28.468L37.1434 28.2627ZM39.6271 26.494C39.6427 26.1829 39.7516 25.9433 39.9538 25.7753C40.1591 25.6042 40.4282 25.5187 40.7611 25.5187C40.9882 25.5187 41.1827 25.5591 41.3444 25.64C41.5062 25.7178 41.6276 25.8251 41.7084 25.962C41.7924 26.0958 41.8344 26.2482 41.8344 26.4193C41.8344 26.6153 41.7831 26.7818 41.6804 26.9187C41.5809 27.0524 41.4611 27.1427 41.3211 27.1893V27.208C41.5016 27.264 41.6416 27.3636 41.7411 27.5067C41.8438 27.6498 41.8951 27.8333 41.8951 28.0573C41.8951 28.244 41.8516 28.4104 41.7644 28.5567C41.6804 28.7029 41.5544 28.818 41.3864 28.902C41.2216 28.9829 41.0224 29.0233 40.7891 29.0233C40.4376 29.0233 40.1513 28.9347 39.9304 28.7573C39.7096 28.58 39.5929 28.3187 39.5804 27.9733H40.2151C40.2213 28.1258 40.2727 28.2487 40.3691 28.342C40.4687 28.4322 40.604 28.4773 40.7751 28.4773C40.9338 28.4773 41.0551 28.4338 41.1391 28.3467C41.2262 28.2564 41.2698 28.1413 41.2698 28.0013C41.2698 27.8147 41.2107 27.6809 41.0924 27.6C40.9742 27.5191 40.7907 27.4787 40.5418 27.4787H40.4064V26.942H40.5418C40.9836 26.942 41.2044 26.7942 41.2044 26.4987C41.2044 26.3649 41.164 26.2607 41.0831 26.186C41.0053 26.1113 40.8918 26.074 40.7424 26.074C40.5962 26.074 40.4827 26.1144 40.4018 26.1953C40.324 26.2731 40.2789 26.3727 40.2664 26.494H39.6271ZM42.3834 28.3373V27.824L43.9094 25.64H44.6701V27.768H45.0807V28.3373H44.6701V29H44.0167V28.3373H42.3834ZM44.0587 26.34L43.1021 27.768H44.0587V26.34Z"
              fill="#393444"
            />
            <path
              d="M7.31933 10.3793H6.022L5.80733 11H5.12133L6.29267 7.738H7.05333L8.22467 11H7.534L7.31933 10.3793ZM7.142 9.85667L6.67067 8.494L6.19933 9.85667H7.142ZM12.2138 7.74267V11H11.5605V8.88133L10.6878 11H10.1932L9.31583 8.88133V11H8.6625V7.74267H9.4045L10.4405 10.1647L11.4765 7.74267H12.2138ZM13.5131 8.27V9.08667H14.6098V9.60467H13.5131V10.468H14.7498V11H12.8598V7.738H14.7498V8.27H13.5131ZM17.2942 11L16.5895 9.90333L15.9502 11H15.2128L16.2395 9.35733L15.1988 7.74267H15.9502L16.6548 8.83467L17.2895 7.74267H18.0268L17.0048 9.38067L18.0455 11H17.2942Z"
              fill="#393444"
            />
            <circle
              cx="40.5"
              cy="27.5"
              r="6.22917"
              stroke="#FF3F34"
              stroke-width="0.541667"
            />
          </g>
          <defs>
            <clipPath id="clip0_5003:119656">
              <rect width="54" height="40" rx="8" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["right"]
};
</script>
<style lang="scss" scoped>
.cvv-help {
  // desktop
  @media screen and (min-width: 992px) {
    position: absolute;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1;
    color: white;
    left: -80%;
    top: -10px;
    border-radius: 6px;
    width: 290px;
    padding: 4px;

    & > div {
      padding: 4px 8px;

      img {
        margin-left: 8px;
      }
    }

    hr {
      display: none;
    }

    &::before {
      content: "";
      border: 8px solid transparent;
      border-left-color: rgba(0, 0, 0, 0.8);
      position: absolute;
      left: 290px;
      top: 16px;
    }

    &.left {
      right: 102%;
      left: unset;

      &::before {
        left: unset;
        right: -16px;
        border-right-color: transparent;
        border-left-color: rgba(0, 0, 0, 0.8);
      }
    }
  }

  // mobile
  @media screen and (max-width: 991px) {
    background: rgba(0, 0, 0, 0.05);
    padding: 4px 8px;
    color: rgba(0, 0, 0, 0.6);

    hr {
      margin: 0;
    }

    & > div {
      padding: 8px;

      img {
        margin-left: 8px;
      }
    }
  }
}
</style>
